import { TextField, Theme, styled } from '@material-ui/core';

const FileField = styled(TextField)<Theme>(({ theme }) => ({
  '& .MuiInput-root': {
    background: theme.palette.common.white,
    border: theme.config.defaultBorder(),
    borderRadius: theme.config.defaultBorderRadius,
    boxShadow: theme.config.defaultBoxShadow,
    padding: theme.spacing(1, 2),
    fontSize: theme.typography.h3.fontSize,
    color: theme.palette.grey['900'],
    '&::before': {
      borderBottom: 'none',
    },
  },
}));

export default FileField;
